import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { Button, ModalDefault, Text } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { escapeHtml } from "@components/ow";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

/** Confirmação da exclusão. O modal fica aberto se o back recusar. */
export default function DeleteDocumentModal({ doc, onClose, onDeleted }) {
  const documentsService = useService("documents");
  const [loading, setLoading] = useState(false);

  function close() {
    if (!loading) onClose();
  }

  async function confirm() {
    setLoading(true);
    try {
      await documentsService.destroy(doc.id);
      toast.success("Documento excluído");
      setLoading(false);
      onDeleted();
    } catch (err) {
      toast.error(err?.response?.data?.msg || "Erro ao excluir o documento");
      setLoading(false);
    }
  }

  return (
    <ModalDefault
      $showModal
      $setShowModal={close}
      $noClose={loading}
      $size="medium"
      $title="Excluir documento?"
      $contentBackground="N0"
      $footer={
        <>
          <Button $text="Cancelar" $variant="outline" $action={close} $isDisabled={loading} $noWidth />
          <Button $text="Excluir documento" $variant="danger" $action={confirm} $isLoading={loading} $noWidth />
        </>
      }
    >
      <Body>
        <Text
          $text="“%s”"
          $replaces={[escapeHtml(doc.filename || "Documento")]}
          $variant="paragraph_small_medium"
          $color="N900"
          $colorEmphasis="N900"
        />
        <Text
          $text="O documento sai da lista da empresa e das pessoas com quem foi compartilhado. A exclusão não tem volta."
          $variant="paragraph_small_medium"
          $color="N700"
        />
      </Body>
    </ModalDefault>
  );
}
